import type {
  HeartbeatActivityState,
  HeartbeatConfig,
  HeartbeatPolicyResult,
} from '../contracts/heartbeat';

export class HeartbeatPolicy {
  constructor(private readonly config: HeartbeatConfig) {}

  canEmit(
    state: HeartbeatActivityState,
    options: { readonly running: boolean; readonly destroyed: boolean }
  ): HeartbeatPolicyResult {
    if (options.destroyed) {
      return { allow: false, reason: 'destroyed' };
    }
    if (!options.running) {
      return { allow: false, reason: 'not_running' };
    }

    const idle = state.idle === true;

    if (!this.config.emitWhenHidden && state.visible === false) {
      return { allow: false, reason: 'hidden' };
    }

    if (!this.config.emitWhenIdle && idle) {
      return { allow: false, reason: 'idle' };
    }

    return { allow: true, reason: 'ok' };
  }

  /**
   * Intervalo do próximo tick:
   * - visível (ou SSR/unknown): `intervalMs`
   * - escondido: `hiddenIntervalMs` (reavalia policy; emite só se emitWhenHidden)
   */
  resolveIntervalMs(state: HeartbeatActivityState): number {
    if (state.visible === false) {
      return this.config.hiddenIntervalMs;
    }
    return this.config.intervalMs;
  }
}
